import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withRouter, RouteComponentProps } from 'react-router';
import { ListItemIcon } from '@material-ui/core';
import { Settings, ExitToApp } from '@material-ui/icons';

type Props = {
    logout: () => void,
    username: string
} & RouteComponentProps

type State = {
    anchorEl: null | HTMLElement
}

class UserMenu extends Component<Props, State>  {
    constructor(props: Props) {
        super(props)

        this.state = {
            anchorEl: null
        }
    }

    handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        this.setState({ anchorEl: event.currentTarget })
    };

    handleClose = () => {
        this.setState({ anchorEl: null })
    };

    render = () => {
        return (
            <div>
                <Button aria-controls="simple-menu" aria-haspopup="true" onClick={this.handleClick}>
                    {this.props.username || "Menu"}
                </Button>
                <Menu
                    id="simple-menu"
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleClose}
                >
                    <MenuItem onClick={() => { this.handleClose(); this.props.history.push('/Account'); }}><ListItemIcon><Settings/></ListItemIcon>My account</MenuItem>
                    <MenuItem onClick={() => { this.handleClose(); this.props.logout(); }}><ListItemIcon><ExitToApp/></ListItemIcon>Logout</MenuItem>
                </Menu>
            </div>
        );
    }
}

export default withRouter(UserMenu);